import React from "react";
import "../CampaignComponent/CampaginComponentCss/ PreAbhiyanSection.css";

export default function PreAbhiyanSection() {
  const items = [
    {
      id: 1,
      text: `राज्यस्तरीय कार्यशाळा दि. २६ ऑगस्ट २०२५ रोजी मा. ग्रामविकास मंत्री यांचे उपस्थितीत पार पडली. या कार्यशाळेसाठी मुख्य कार्यकारी अधिकारी, प्रकल्प संचालक जिल्हा ग्रामीण विकास यंत्रणा, उपमुख्य कार्यकारी अधिकारी (पंचायत) जिल्हा कार्यक्रम अधिकारी, मनरेगा, प्रकल्प संचालक- पाणी व स्वच्छता, निवडक सरपंच व ग्रामपंचायत अधिकारी उपस्थित होते.`,
    },
    {
      id: 2,
      text: `जिल्हास्तरीय कार्यशाळा- दि. ०५ सप्टेंबर २०२५- आज संपन्न होत असून या कार्यशाळेसाठी सन्मा. लोकप्रतिनिधी, सरपंच, जिल्हा व तालुकास्तरीय वरिष्ठ अधिकारी व ग्रामपंचायत अधिकारी अशा साधारण २००० प्रशिक्षणार्थींना प्रशिक्षण देण्यात येत आहे. आयोजनाची जबाबदारी- मुख्य कार्यकारी अधिकारी, जिल्हा परिषद यांची आहे.`,
    },
    {
      id: 3,
      text: `तालुका/ पंचायतस्तरीय कार्यशाळा- या कार्यशाळा दि. ६ ते १० सप्टेंबर २०२५ या कालावधी दरम्यान तालुकास्तरावर आयोजित करण्यात येणार आहेत. या कार्यशाळेसाठी तालुकास्तरीय वरिष्ठ अधिकारी, पर्यवेक्षकीय अधिकारी, ग्रामपंचायत सदस्य, ग्रामपंचायत कर्मचारी, रोजगार सेवक, संगणक परिचालक यांना प्रशिक्षण देण्यात येणार आहे. आयोजनाची जबाबदारी- गट विकास अधिकारी, पंचायत समिती यांची असेल.`,
    },
    {
      id: 4,
      text: `ग्रामस्तरीय कार्यशाळा- या कार्यशाळा दि. ११ ते १५ सप्टेंबर २०२५ या कालावधी दरम्यान ग्रामस्तरावर आयोजित येणार आहेत. या कार्यशाळेसाठी सरपंच, ग्रामपंचायत सदस्य, ग्रामपंचायत अधिकारी व कर्मचारी, ग्रामस्थ, महिला बचत गट, युवक यांना प्रशिक्षण देण्यात येणार आहे.`,
    },
    {
      id: 5,
      text: `विशेष ग्रामसभांचे आयोजन- दि. १७ सप्टेंबर रोजी जिल्ह्यातील सर्व ग्रामपंचायतीमध्ये विशेष ग्रामसभांचे आयोजन करण्यात येणार आहे. या ग्रामसभांमध्ये मुख्यमंत्री समृद्ध पंचायतराज अभियानाबाबत चर्चा करण्यात येऊन ग्रामपंचायत अभियानात सहभागी होत असल्याबाबतचा ठराव करून गावातील ग्रामस्थांचे अभियानातील घटकनिहाय लहान-लहान गट स्थापन करण्यात येतील.`,
    },
  ];

  return (
    <section className="pre-wrapper">
      <h2 className="pre-heading">अभियानाची पूर्वतयारी</h2>
      <p className="pre-subtext">
        राज्य, जिल्हा, तालुका व ग्रामस्तरीय कार्यशाळांच्या माध्यमातून ग्रामस्थांना व अधिकारी कर्मचारी यांना अभियानाचे प्रशिक्षण देणे.
      </p>

      <div className="pre-list">
        {items.map((item, index) => (
          <div
            key={item.id}
            className="pre-card-box"
            style={{ justifyContent: index % 2 === 0 ? "flex-start" : "flex-end" }}
          >
            {index % 2 !== 0 && (
              <div className="pre-number outside-number left-num">{item.id}</div>
            )}

            <div className="pre-card">
              <div className="pre-content">
                <p className="pre-text">{item.text}</p>
              </div>
            </div>

            {index % 2 === 0 && (
              <div className="pre-number outside-number right-num">{item.id}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
